import { useState, useMemo } from 'react';
import useOrders from 'data/hooks/useOrders';
import { OrdersFiltered } from './types';

const DefaultOrdersFiltered: OrdersFiltered = {
  active: [],
  completed: [],
  scheduled: [],
  cancelled: [],
};

const useConnect = () => {
  const [search, setSearch] = useState<string | undefined>(undefined);
  const [selectedBrandId, setSelectedBrandId] =
    useState<string>('all-restaurants');
  const { orders: allOrders, isLoading: isLoadingOrders } = useOrders();

  const orders = useMemo(
    () =>
      (allOrders || []).reduce<OrdersFiltered>((acum, order) => {
        if (
          selectedBrandId !== 'all-restaurants' &&
          order.brand.id !== selectedBrandId
        ) {
          return acum;
        }

        if (
          search !== undefined &&
          search !== '' &&
          !order.customer.name.displayName
            .toLocaleLowerCase()
            .includes(search.toLocaleLowerCase()) &&
          !order.brand.name
            .toLocaleLowerCase()
            .includes(search.toLocaleLowerCase()) &&
          !order.integration.name
            .toLocaleLowerCase()
            .includes(search.toLocaleLowerCase()) &&
          !order.integration.orderId
            .toLocaleLowerCase()
            .includes(search.toLocaleLowerCase())
        ) {
          return acum;
        }

        return {
          active:
            order.status.key === 'PENDING' || order.status.key === 'READY'
              ? acum.active.concat(order)
              : acum.active,
          completed:
            order.status.key === 'COMPLETE'
              ? acum.completed.concat(order)
              : acum.completed,
          scheduled:
            order.status.key === 'SCHEDULED'
              ? acum.scheduled.concat(order)
              : acum.scheduled,
          cancelled:
            order.status.key === 'CANCELLED'
              ? acum.cancelled.concat(order)
              : acum.cancelled,
        };
      }, DefaultOrdersFiltered),
    [allOrders, selectedBrandId, search],
  );

  return {
    search,
    setSearch,
    orders,
    selectedBrandId,
    isLoadingOrders,
    setSelectedBrandId,
    isSearching: search !== undefined,
  };
};

export default useConnect;
